import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export const Filters = ({
    filters,
    handleFilters,
    tiposProspectos,
    listaClasificacionTask,
}) => {
    return (
        <div className="flex flex-wrap gap-2">
            <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="crm-comercial-label" shrink>Estado comercial</InputLabel>
                <Select labelId="crm-comercial-label" label="Estado comercial" displayEmpty name="estado_comercial" value={filters.estado_comercial ?? 'abierta'} onChange={handleFilters}>
                    <MenuItem value="abierta">Abiertas</MenuItem><MenuItem value="ganada">Ganadas</MenuItem><MenuItem value="perdida">Perdidas</MenuItem><MenuItem value="">Todos los resultados</MenuItem>
                </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="crm-estado-label" shrink>Archivo</InputLabel>
                <Select
                    labelId="crm-estado-label"
                    displayEmpty
                    label="Archivo"
                    id="estado"
                    name="estado"
                    value={filters.estado || ""}
                    onChange={handleFilters}
                    className="p-list-capitalize"
                >
                    <MenuItem value="" key="">
                        Todos
                    </MenuItem>
                    {[{ id: 'activo', nombre: 'activos' }, { id: 'archivado', nombre: 'archivados' }].map((item) => (
                        <MenuItem
                            value={item.id}
                            key={item.id}
                            className="p-list-capitalize"
                        >
                            {item.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 200 }} className="ms-2">
                <InputLabel id="demo-simple-select-label">Tipo de prospecto</InputLabel>
                <Select
                    label="Tipo de prospecto"
                    id="id_tipo"
                    name="id_tipo"
                    value={filters.id_tipo || ""}
                    onChange={handleFilters}
                    className="p-list-capitalize"
                >
                    <MenuItem value="" key="">
                        Ninguno
                    </MenuItem>
                    {tiposProspectos.map((item) => (
                        <MenuItem
                            value={item.id}
                            key={item.id}
                            className="p-list-capitalize"
                        >
                            {item.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};


